export default "__VITE_ASSET__B7QCGeS1__"